module.exports = __webpack_public_path__ + "img/icon3.bd8692b6.png";